import { BenefitsPageContent } from "./components/BenefitsPageContent/BenefitsPageContent";
import { BenefitsPageHeader } from "./components/BenefitsPageHeader/BenefitsPageHeader";

export function BenefitsPage() {
  return (
    <>
      <BenefitsPageHeader />
      <BenefitsPageContent />
    </>
  );
}
